import React from 'react'
import CloseIcon from './img/close.svg?react'
import TimeIcon from "./img/time.svg?react";
import { animated } from "@react-spring/web";
import "./style.scss"

export const wrongAnswerPopupSpringSettings = {
    from: {
      opacity: 0,
      transform: "translateX(-50%) scale(0)",
    },
    enter: {
      opacity: 1,
      width: "100%",
      bottom: "calc(100% + 12px)",
      left: "50%",
      transform: "translateX(-50%) scale(1)",
    },
    leave: {
      opacity: 0,
      transform: "translateX(-50%) scale(0)",
    },
    config: {
      duration: 200,
    }
}

export default function WrongAnswerPopup({ onClose, style }) {
  return (
    <animated.div className='wrong-answer-popup' style={style}>
      <button className="close" onClick={onClose} aria-label='schließen'>
        <CloseIcon />
      </button>
      <div className="inner">
        <TimeIcon />
        <p><strong>Fast geschafft.</strong> Versuche es <br />noch einmal.</p>
      </div>
    </animated.div>
  )
}
